var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_1449_118)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 0.412109C4.5 0.412109 0 4.86155 0 10.2997C0 12.4421 0.666667 14.4196 1.83333 16.0675V21.3409C1.83333 22.3297 3 22.8241 3.75 22.0825L6.33333 19.5282C7.5 19.9402 8.75 20.1874 10 20.1874C15.5 20.1874 20 15.738 20 10.2997C20 4.86155 15.5 0.412109 10 0.412109Z",
    fill: "#EDDFF7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.9166 9.31098H10.9166V6.34469C10.9166 5.85031 10.4999 5.35593 9.91658 5.35593C9.33325 5.35593 8.91659 5.76791 8.91659 6.34469V9.31098H6.08325C5.58325 9.31098 5.08325 9.72297 5.08325 10.2997C5.08325 10.7941 5.49992 11.2885 6.08325 11.2885H9.08325V14.2548C9.08325 14.7492 9.49992 15.2436 10.0833 15.2436C10.6666 15.2436 11.0833 14.8316 11.0833 14.2548V11.2885H14.0833C14.5833 11.2885 15.0833 10.8765 15.0833 10.2997C14.9166 9.72297 14.4999 9.31098 13.9166 9.31098Z",
    fill: "#A461D8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1449_118"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 22,
    fill: "white",
    transform: "translate(0 0.412109)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.ea53361f8c295d0fd816cab80acaf2d9.svg";
export { ForwardRef as ReactComponent };